import { PAGINATION_FIRST_PAGE } from "@/constants";
import { ActionTree } from "vuex";
import { HomeState } from ".";
import { RootState } from "..";
import eventsApi from "../../api/events.api";
import statisticsApi from "../../api/statistics.api";
import { RootActionTypes } from "../root-actions";
import { HomeMutationTypes } from "./home.mutations";
import * as Sentry from "@/utils/logger.util";

export const HomeActionTypes = {
  FetchMainSportEvents: "FETCH_MAIN_SPORT_EVENTS",
  FetchSportEventsList: "FETCH_SPORT_EVENTS_LIST",
  FetchStatistics: "FETCH_STATISTICS"
};

export const actions: ActionTree<HomeState, RootState> = {
  async [HomeActionTypes.FetchMainSportEvents]({ commit, dispatch }) {
    try {
      const response = await eventsApi.getEvents();
      commit(HomeMutationTypes.SetMainSportEvents, response.data);
    } catch (error) {
      Sentry.captureException(error);
      dispatch(RootActionTypes.HandleApiError, error, { root: true });
    }
  },
  async [HomeActionTypes.FetchSportEventsList]({ commit, dispatch }) {
    try {
      const response = await eventsApi.getEvents(PAGINATION_FIRST_PAGE);
      commit(HomeMutationTypes.SetSportEventsList, response.data);
    } catch (error) {
      Sentry.captureException(error);
      dispatch(RootActionTypes.HandleApiError, error, { root: true });
    }
  },
  async [HomeActionTypes.FetchStatistics]({ commit, dispatch }) {
    try {
      const response = await statisticsApi.getStatistics();
      commit(HomeMutationTypes.SetStatistics, response.data.data);
    } catch (error) {
      Sentry.captureException(error);
      dispatch(RootActionTypes.HandleApiError, error, { root: true });
    }
  }
};
